"use client";

import LogosCarousel from "./logosCarousel";
import CardsSection from "./cardsSection";
import ServicesSection from "./servicesSection";
import MetricsSection from "./metricsSection";
import HeroSection from "./hero";
import StepsSection from "./stepsSection";
import ResultsSection from "./resultsSection";
import TextSection from "./textSection";
import FrameworkSection from "./frameworkSection";
import ExpectSection from "./expectSection";
import CaseStudiesSection from "./caseStudiesSection";
import ShowcaseSection from "./showcaseSection";
import FaqSection from "./faqSection";
import ContactInfoSection from "./contactInfoSection";
import ChannelsSection from "./channelsSection";
import SectionHeader from "../sectionHeader";
import ArrowsSection from "./arrowsSection";

interface Props {
  data?: any;
}

export default function Sections({ data }: Props) {
  return (
    <>
      {data?.map((section: any, index: number) => {
        switch (section._type) {
          case "logosCarousel":
            return <LogosCarousel key={index} data={section} />;
          case "cards":
          case "anti":
          case "tmrwLetters":
          case "praxe":
            return <CardsSection key={index} data={section} />;
          case "servicesMenu":
            return <ServicesSection key={index} data={section} />;
          case "metrics":
            return <MetricsSection key={index} data={section} />;
          case "textSection":
            return <TextSection key={index} data={section} />;
          case "cta":
            return <HeroSection key={index} data={{ ...section, cta: true }} />;
          case "steps":
            return <StepsSection key={index} data={section} />;
          case "results":
            return <ResultsSection key={index} data={section} />;
          case "framework":
            return <FrameworkSection key={index} data={section} />;
          case "expect":
            return <ExpectSection key={index} data={section} />;
          case "caseStudies":
            return <CaseStudiesSection key={index} data={section} />;
          case "showcase":
            return <ShowcaseSection key={index} data={section} />;
          case "faq":
            return <FaqSection key={index} data={section} />;
          case "contactInfo":
            return <ContactInfoSection key={index} data={section} />;
          case "channels":
            return <ChannelsSection key={index} data={section} />;
          case "arrows":
            return <ArrowsSection key={index} data={section} />;
          case "header":
            return (
              <div key={index} className="container mx-auto pt-16">
                <SectionHeader title={section.title} headline={section.headline} text={section.text} />
              </div>
            );
        }
      })}
    </>
  );
}
